import {
  PROJECT_DETAILS
} from "./type";

const initialState = {
  projectDetails: []
}

const projectConfigurationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default projectConfigurationReducer;